// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"edb0ed4f","488":"cc67c2f7"}[chunkId] + ".chunk.js";
};